import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import makeStyles from "@material-ui/core/styles/makeStyles";
import CardTitle from "@saleor/components/CardTitle";
import { sectionNames } from "@saleor/intl";
import React from "react";
import { useIntl } from "react-intl";

export interface ProductStatusProps {
  data: {
    productStatus: string;
  };
  disabledOptions?: string[];
  onChange: (event: React.ChangeEvent<any>) => void;
}

const useStyles = makeStyles(
  theme => ({
    content: {
      paddingTop: theme.spacing(2)
    },
    hr: {
      margin: theme.spacing(2, 0)
    },
    select: {
      margin: theme.spacing(2, 0)
    }
  }),
  {
    name: "ProductStatus"
  }
);

const ProductStatus: React.FC<ProductStatusProps> = ({
  data: { productStatus },
  disabledOptions,
  onChange
}) => {
  const intl = useIntl();
  const classes = useStyles({});
  const availableOptions = ["Draft", "Ready", "Unlisted"];

  return (
    <Card>
      <CardTitle title={intl.formatMessage(sectionNames.productStatus)} />
      <CardContent className={classes.content}>
        <RadioGroup
          name="productStatus"
          value={productStatus || "DRAFT"}
          onChange={onChange}
        >
          {availableOptions.map((item, index) => (
            <FormControlLabel
              id={`${item.toLowerCase()}Radio`}
              key={index}
              disabled={
                disabledOptions && disabledOptions.includes(item.toLowerCase())
                  ? true
                  : false
              }
              value={item.toUpperCase()}
              control={<Radio color="primary" />}
              label={item}
            />
          ))}
        </RadioGroup>
      </CardContent>
    </Card>
  );
};

ProductStatus.displayName = "ProductStatus";
export default ProductStatus;
